import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const ChartBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M12.3996 1.60156C11.7369 1.60156 11.1996 2.13882 11.1996 2.80156V13.2016C11.1996 13.8643 11.7369 14.4016 12.3996 14.4016H13.1996C13.8624 14.4016 14.3996 13.8643 14.3996 13.2016V2.80156C14.3996 2.13882 13.8624 1.60156 13.1996 1.60156H12.3996Z"
      fill="currentColor"
    />
    <path
      d="M7.59961 4.80156C6.93687 4.80156 6.39961 5.33882 6.39961 6.00156V13.2016C6.39961 13.8643 6.93687 14.4016 7.59961 14.4016H8.39961C9.06235 14.4016 9.59961 13.8643 9.59961 13.2016V6.00156C9.59961 5.33882 9.06235 4.80156 8.39961 4.80156H7.59961Z"
      fill="currentColor"
    />
    <path
      d="M2.79961 8.00156C2.13687 8.00156 1.59961 8.53882 1.59961 9.20156V13.2016C1.59961 13.8643 2.13687 14.4016 2.79961 14.4016H3.59961C4.26235 14.4016 4.79961 13.8643 4.79961 13.2016V9.20156C4.79961 8.53882 4.26235 8.00156 3.59961 8.00156H2.79961Z"
      fill="currentColor"
    />
  </IconContainer>
);
